import {resources} from "../../../../models/resource/resources";

export const addTelegramAccountModalName = 'add-telegram-account';

export const telegramAccountsResourceType = resources['telegram-accounts'];
export const telegramResourceType = resources['telegram'];
